import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseSmell } from "./UseSmell";

export default function ScentAutoComplete(props) {
  const { getAllSmellList } = UseSmell();
  const [productScentRes, setProductScentRes] = useState();
  const [selectedSense, setSelectedSense] = useState();

  useEffect(() => {
    getAllSmellList((scents) => {
      setProductScentRes(scents);
    });
  }, []);

  useEffect(() => {
    if (productScentRes && props.selectedScentID) {
      setSelectedSense(
        productScentRes.scents.find((m) => m.id == props.selectedScentID)
      );
    }
  }, [productScentRes, props.selectedScentID]);

  useEffect(() => {
    if (selectedSense) {
      props.setter({
        ...props.lvl2State,
        scentID: selectedSense.id,
      });
    }
  }, [selectedSense]);

  return productScentRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={selectedSense ? selectedSense : ""}
        options={productScentRes.scents ? productScentRes.scents : []}
        getOptionLabel={(scents) => (scents.name ? scents.name : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField error={props.validation} {...params} label="رایحه" />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name ? option.name : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedSense(newValue);
          } else {
            setSelectedSense();
            props.setter({
              ...props.lvl2State,
              scentID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllSmellList((scents) => {
            setProductScentRes(scents);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/productscent" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
